__turbopack_context__.v({
  "contentGroup": "BlockSimpleProductList-module-scss-module__f26K3G__contentGroup",
  "contentWrapper": "BlockSimpleProductList-module-scss-module__f26K3G__contentWrapper",
  "ctaButton": "BlockSimpleProductList-module-scss-module__f26K3G__ctaButton",
  "endCardContent": "BlockSimpleProductList-module-scss-module__f26K3G__endCardContent",
  "endCardImage": "BlockSimpleProductList-module-scss-module__f26K3G__endCardImage",
  "endCardText": "BlockSimpleProductList-module-scss-module__f26K3G__endCardText",
  "eyebrow": "BlockSimpleProductList-module-scss-module__f26K3G__eyebrow",
  "fade-in": "BlockSimpleProductList-module-scss-module__f26K3G__fade-in",
  "flushBottom": "BlockSimpleProductList-module-scss-module__f26K3G__flushBottom",
  "flushTop": "BlockSimpleProductList-module-scss-module__f26K3G__flushTop",
  "headline": "BlockSimpleProductList-module-scss-module__f26K3G__headline",
  "headlineWrapper": "BlockSimpleProductList-module-scss-module__f26K3G__headlineWrapper",
  "iconGroup": "BlockSimpleProductList-module-scss-module__f26K3G__iconGroup",
  "iconWrapper": "BlockSimpleProductList-module-scss-module__f26K3G__iconWrapper",
  "listItem": "BlockSimpleProductList-module-scss-module__f26K3G__listItem",
  "productList": "BlockSimpleProductList-module-scss-module__f26K3G__productList",
  "root": "BlockSimpleProductList-module-scss-module__f26K3G__root",
  "theme--makers-reserve": "BlockSimpleProductList-module-scss-module__f26K3G__theme--makers-reserve",
});
